export default {
  "box-name": "en-style2",
  "public-btn-text1": "Register Now",
  "public-btn-text2": "All Products",
  screen0: {
    title: "CFD Dividend",
    desc: 'Please note\'ollection of CFD dividend will be reflected in the balance on your MT4 account as a deposit or withdrawal, annotated as "Dividend".',
  },
  screen1: {
    title: "Secure Transaction",
  },
  screen2: {
    title: "The financial world is at your fingertips",
  },
  股息调整: "Dividend Adjustments",
  了解您在股票和指数差价合约交易中的股息调整和分配机制:
    "Learn how dividend adjustments and allocations work in stock, index, and ETF CFDs trading.",
  了解指数差价合约: "Learn Index CFDs",
  了解股票差价合约: "Learn Stock CFDs",
  股息是上市公司从利润或保留资金中定期分配给股东的资金:
    "Dividends are regular income distributions by listed companies or ETFs. For stock, index, and ETF CFDs, they also undergo corresponding cash adjustments based on the actual dividend paid.",
  除息日与交易优化: "Ex-dividend Dates and Trading Optimisations",
  指数差价合约的除息日由指数提供商根据成分股设定:
    "Ex-dividend dates are set by the stock, index, or ETF issuer. On these days, long CFD positions receive cash dividends, while short positions are charged. Monitoring upcoming dates helps manage and optimise your yields effectively.",
  股息调整明细: "Dividend Adjustment Details",
  差价合约交易中相关产品的股息数据:
    "The dividend data for related products in CFDs trading is displayed separately for long (buy) and short (sell) dividends.",
  交易产品: "Trading Products",
  多头股息: "Long Dividends",
  空头股息: "Short Dividends",
  除息日: "Ex-dividend Dates",
  即刻交易: "Trade Now ",
  股息的常见问题: "Dividend FAQ",
  qaList: [
    {
      q: "1. What are dividends and ex-dividend dates?",
      a: [
        "Dividends are funds regularly distributed to shareholders from the profits or assets of listed companies or ETFs. The ex-dividend date marks when the asset officially pays out and its price is adjusted, typically with net value or quotes updated before the market opens.",
        "In CFD products (stocks, indices, or ETFs), ex-dividend events trigger price adjustments, with the MT4/MT5 system crediting long positions or debiting short positions with a corresponding cash amount.",
      ],
    },
    {
      q: "2. Timing of dividend adjustments",
      a: [
        "Dividend adjustments for index CFDs typically reflect in your MT4/MT5 trading account between 00:00 and 01:00 (GMTtime) on the ex-dividend date, labelled as 'Dividend.'",
        "Dividend adjustments for stock and ETF CFDs are typically reflected in your MT5 trading account before 16:30 (MT time) on the ex-dividend date, labelled as 'Dividend.'",
      ],
    },
    {
      q: "3. Impacts of dividends on index trading",
      a: [
        "Holding long position (Buy): The dividend adjustment will be credited to your MT4/MT5 account.",
        "Holding short position (Sell): The corresponding amount will be deducted from your MT4/MT5 account.",
        "Note: Dividend adjustments for ETF CFDs follow the same principle and are based on the listed company’s official payout announcement."
      ],
    },
    {
      q: "4. Calculation formulas for dividend adjustments",
      a: [
        "Long position (buy) calculation formula: Lots × Contract Size × Long Dividend Amount (calculated in index currency).",
        "Short position (sell) calculation formula: Lots × Contract Size × Short Dividend Amount (calculated in index currency).",
      ],
    },
    {
      q: "5. Example of dividend adjustment calculation",
      a: [
        "For example, with SPXUSD, assuming the ex-dividend date is 11 October 2024, the long dividend amount is 0.050 USD, and the short dividend amount is -0.050 USD.If you hold a long position (buy) of 1 standard lot of SPXUSD at the close on the day before the ex-dividend date (10 October 2024), the calculation for the dividend adjustment is as follows:",

        "Dividend adjustment = 1 (standard lot) × 100 (contract size) × 0.050 USD (long dividend amount) = 5 USD.",

        "On the ex-dividend date, between 00:00 and 01:00 (MT time), 5 USD will be credited to your MT4/MT5 account, labelled as 'Dividend.'",

        "If you hold a short position (sell), 5 USD will be deducted from your MT4/MT5 account, noted as 'Dividend.'",
      ],
    },
    {
      q: "6. Important Details ",
      a: [
        "Dividend adjustments apply to stock, index, and ETF CFDs, and are automatically calculated based on the ex-dividend payout, position direction, and trade size. For ETF CFDs, dividend amounts are determined by the official announcements of the underlying fund and may fluctuate depending on changes in the fund's assets. These adjustments do not affect spreads or trading costs, but they do impact your account’s net value and profit or loss. To check upcoming dividend events for specific ETFs or indices, refer to our [Daily Adjustment Notice] or contact your account manager."
      ],
    },
  ],
};
